import { render, staticRenderFns } from "./SummaryContainer.vue?vue&type=template&id=a5e0fcb2&scoped=true&"
import script from "./SummaryContainer.vue?vue&type=script&lang=ts&"
export * from "./SummaryContainer.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryContainer.vue?vue&type=style&index=0&id=a5e0fcb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e0fcb2",
  null
  
)

export default component.exports